import {Component, input, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-plain-input-socket",
    templateUrl: "./plain-input-socket.component.html",
    styleUrls: ["./plain-input-socket.component.scss"],
})
export class PlainInputSocketComponent {
    readonly $label = input.required<string>({alias: "label"})
    readonly $value = input.required<string | undefined>({alias: "value"})

    readonly $connected = input(false, {alias: "connected"})
}
